import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Alert,
} from "reactstrap";
import { FetchData, UploadFile } from "./utils/DataFetch";
import { GetCookie, Timeout } from "./utils/Common";

function toSendEmailRequest(model) {
  return {
    Body: model.Body,
    EmailCC: model.EmailCC,
    EmailTo: model.EmailTo,
    EmailType: model.EmailType,
    EmailSource: model.EmailSource,
    JobIds: model.JobIds,
    JobNums: model.JobNums,
    Subject: model.Subject
  };
}

export class RepFormEmail extends Component {
  static displayName = RepFormEmail.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    this.state = {
      model: props.model,
      activeTab: "1",
    };

    this.handleChange = this.handleChange.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.sendRequestAuth = this.sendRequestAuth.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
  }

  componentDidMount() {
    //document.addEventListener('keydown', this.keydownHandler);
  }

  componentWillUnmount() {
    //document.removeEventListener('keydown', this.keydownHandler);
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  sendEmail() {
    let model = this.state.model;
    model.EmailFrom = this.user.email;

    FetchData("/sendrepemail", "POST", this.user.token, toSendEmailRequest(this.state.model)).then((data) => {
      if (data === "Success") {
        this.props.handleSaveEventSuccess({
          message:
            data === "Success" ? "Email has been sent successfully" : data,
          modal: data === "Success" ? false : true,
          color: data === "Success" ? "success" : "warning",
        });
      } else {
        this.handleSaveEventSuccess({
          message: data === "Success" ? "Email was not sent" : data,
          modal: data === "Success" ? false : true,
          color: data === "Success" ? "success" : "warning",
        });
      }
    });
  }

  sendRequestAuth() {
    FetchData(
      "/SendRequestAuth",
      "POST",
      this.user.token,
      toSendEmailRequest(this.state.model)
    ).then((data) => {
      // JobIds may be comma-separated for bulk authorization emails.
      // Log a "Rep Request Auth" history entry for every job in the list.
      const jobIds = (this.state.model.JobIds || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);

      const historyPromises = jobIds.map((jobId) => {
        var formData = new FormData();
        formData.append("EventType", "insert");
        formData.append("JobHistoryId", null);
        formData.append("JobId", jobId);
        formData.append("Description", this.state.model.Body);
        formData.append("JobHistoryType", "Rep Request Auth");
        formData.append("CreateByUserId", this.user.userid);
        return UploadFile("/savejobhistory", this.user.token, formData);
      });

      Promise.all(historyPromises).then((results) => {
        const allSuccess = results.every((r) => r === "Success");
        if (allSuccess) {
          this.props.handleSaveEventSuccess({
            message: "Email has been sent successfully",
            modal: false,
            color: "success",
          });
        } else {
          this.handleSaveEventSuccess({
            message: "Email has not been sent",
            modal: true,
            color: "warning",
          });
        }
      });
    });
  }

  handleChange(e) {
    let model = { ...this.state.model };
    model[e.target.name] = e.target.value;

    this.setState({ model });
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modal}
        toggle={this.props.setModal}
        style={{ width: "1024px", height: "600px" }}
        backdrop="static"
      >
        <ModalHeader>Rep Email</ModalHeader>
        <ModalBody>
          <div>
            <Row>
              <Col>
                <Alert
                  color={this.props.alert.color}
                  isOpen={this.props.alert.isOpen}
                >
                  {this.props.alert.message}
                </Alert>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText className="no-border">
                    Email To:
                  </InputGroupText>
                  <Input
                    name="EmailTo"
                    className="form-control form-control-text"
                    placeholder="Email To"
                    value={this.state.model.EmailTo}
                    onChange={this.handleChange}
                    readOnly={this.state.model.EmailSource === "RepEmail"}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText
                    className="no-border"
                    style={{ width: "54px" }}
                  >
                    CC:
                  </InputGroupText>
                  <Input
                    name="EmailCC"
                    className="form-control form-control-text"
                    placeholder="CC Email"
                    value={this.state.model.EmailCC}
                    onChange={this.handleChange}
                    readOnly={this.state.model.EmailSource === "RepEmail"}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText
                    className="no-border"
                    style={{ width: "54px" }}
                  >
                    Subject:
                  </InputGroupText>
                  <Input
                    name="Subject"
                    className="form-control form-control-text"
                    placeholder="Subject"
                    value={this.state.model.Subject}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <textarea
                  name="Body"
                  rows="15"
                  className="no-border form-control-text"
                  style={{ width: "100%" }}
                  onChange={this.handleChange}
                >
                  {this.state.model.Body}
                </textarea>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            hidden={this.state.model.EmailType === "email1" ? null : "hidden"}
            onClick={this.sendRequestAuth}
          >
            Request Auth
          </Button>
          <Button
            color="secondary"
            size="sm"
            hidden={this.state.model.EmailSource === "RepEmail" ? "hidden" : null}
            onClick={this.sendEmail}
          >
            Send Email
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
